import React from "react";
import ReactDOM from "react-dom/client";
import Layout from "./pages/layout.js";
import injectContext from "./store/appContext.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const LayoutWithContext = injectContext(Layout);

root.render(
  <React.StrictMode>
    <LayoutWithContext />
  </React.StrictMode>,
);
